import ReactRailsUJS from 'react_ujs'

const ENTRIES_ROOT_SELECTOR = '[data-challenge-entries-root]'
const PAGINATION_SELECTOR = '[data-challenge-pagination]'
let isFetchingEntries = false

const getEntriesRoot = () => document.querySelector(ENTRIES_ROOT_SELECTOR)

const parseEntriesRoot = (htmlString) => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlString, 'text/html')

  return doc.querySelector(ENTRIES_ROOT_SELECTOR)
}

const updateEntriesRoot = (newRoot, url) => {
  const currentRoot = getEntriesRoot()

  if (!currentRoot || !newRoot) {
    return false
  }

  currentRoot.innerHTML = newRoot.innerHTML

  if (ReactRailsUJS && typeof ReactRailsUJS.mountComponents === 'function') {
    ReactRailsUJS.mountComponents(currentRoot)
  }

  const urlWithAnchor = new URL(url.toString(), window.location.origin)
  urlWithAnchor.hash = 'section-entries'
  window.history.pushState({}, '', urlWithAnchor.toString())
  currentRoot.scrollIntoView({ behavior: 'smooth', block: 'start' })

  return true
}

const fetchEntriesPage = async (url) => {
  const response = await fetch(url.toString(), {
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    credentials: 'same-origin',
  })

  if (!response.ok) {
    throw new Error('Failed to fetch challenge entries page')
  }

  const htmlString = await response.text()

  return parseEntriesRoot(htmlString)
}

const handlePaginationClick = async (event) => {
  const paginationNav = event.target.closest(PAGINATION_SELECTOR)

  if (!paginationNav) {
    return
  }

  const link = event.target.closest('a')
  const entriesRoot = getEntriesRoot()

  if (!link || !entriesRoot || !paginationNav.contains(link)) {
    return
  }

  event.preventDefault()

  if (isFetchingEntries) {
    return
  }

  isFetchingEntries = true
  entriesRoot.setAttribute('data-challenge-entries-loading', 'true')

  const requestUrl = new URL(link.href, window.location.origin)

  try {
    const newEntriesRoot = await fetchEntriesPage(requestUrl)

    if (!updateEntriesRoot(newEntriesRoot, requestUrl)) {
      window.location.assign(link.href)
    }
  } catch (error) {
    window.location.assign(link.href)
  } finally {
    entriesRoot.removeAttribute('data-challenge-entries-loading')
    isFetchingEntries = false
  }
}

const initChallengeEntriesPagination = () => {
  if (typeof document === 'undefined') {
    return
  }

  document.addEventListener('click', handlePaginationClick)
}

export default initChallengeEntriesPagination
